module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-white-4-337678aef3353f61befb78d64b0687ac.webp";